import apiClient from './apiClient';

export interface AuditEvent {
  id: string;
  account_id: number;
  actor_id: string;
  actor_name: string;
  entity_type: string;
  entity_id: string;
  action: string;
  changes: { field: string; from?: unknown; to?: unknown }[];
  metadata?: Record<string, unknown>;
  ip_address?: string;
  created_at: string;
}

interface AuditEventsResponse {
  data: AuditEvent[];
  meta: { total: number; page: number; limit: number; total_pages: number };
}

export interface GetAuditEventsParams {
  entity_type: string;
  entity_id?: string;
  action?: string[];
  search?: string;
  page?: number;
  limit?: number;
}

export const getAuditEvents = async (params: GetAuditEventsParams): Promise<AuditEventsResponse> => {
  const qp = new URLSearchParams();
  qp.append('entity_type', params.entity_type);
  if (params.entity_id) qp.append('entity_id', params.entity_id);
  if (params.search) qp.append('search', params.search);
  if (params.page) qp.append('page', params.page.toString());
  if (params.limit) qp.append('limit', params.limit.toString());
  if (params.action?.length) params.action.forEach(a => qp.append('action', a));

  const response = await apiClient.get(`/audit/employee/events?${qp.toString()}`);
  return response.data;
};
